import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=0d7d6d7c&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
import style0 from "./EventDetails.scss?vue&type=style&index=0&id=0d7d6d7c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d6d7c",
  null
  
)

export default component.exports